/** Auth form routes — no admin cold-boot handoff; preReact must release on React mount. */
export const AUTH_PUBLIC_PATH_PREFIXES = ['/login', '/forgot-password', '/reset-password'] as const;

/** Public share view — outside AdminLayout; same preReact early-release semantics as auth forms. */
export const PUBLIC_SHARE_PATH_PREFIX = '/share' as const;

function matchesPrefix(pathname: string, prefix: string): boolean {
  return pathname === prefix || pathname.startsWith(`${prefix}/`);
}

export function isAuthPublicPath(pathname: string): boolean {
  return AUTH_PUBLIC_PATH_PREFIXES.some((prefix) => matchesPrefix(pathname, prefix));
}

export function isPublicSharePath(pathname: string): boolean {
  return matchesPrefix(pathname, PUBLIC_SHARE_PATH_PREFIX);
}

/**
 * Routes that skip AdminLayout cold-boot (`hasSettledOnce`) and release `#pre-react-boot-splash`
 * after React bootstrap — auth forms + public share.
 */
export function isPreReactEarlyReleasePath(pathname: string): boolean {
  return isAuthPublicPath(pathname) || isPublicSharePath(pathname);
}
